import React from 'react';

import { useState, useEffect } from 'react';

import makeStyles from '@mui/styles/makeStyles';


import DialogContent from '@mui/material/DialogContent';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import FormControlLabel from '@mui/material/FormControlLabel';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import TextField from '@mui/material/TextField';


import { ReclamationActionDetailType } from 'constants.js';
import { ReclamationActionDetailCodes } from 'constants.js';


const useStyles = makeStyles((theme) => ({
    formControl: {
        width: '100%',
        marginBottom: theme.spacing(1)
    },
}));


/* Liste des réponses possibles */
const garantieLabel = "Valider le type de prise en charge";
const garanties = [
    'Sous garantie constructeur',
    'Hors-garantie constructeur',
];



const choixSousGarantie = [
    'Avoir',
    'Echange réparation',
];


function DemandeExpertiseFournisseurDialogContent({ onChange, action }) {

    const classes = useStyles();

    const [garantie, setGarantie] = useState('');

    const [montantDevis, setMontantDevis] = useState('');
    const [proposition, setProposition] = useState('');

    const [sousGarantie, setSousGarantie] = useState('');


    useEffect(() => {
        onChange(null);
    }, [onChange]);



    useEffect(() => {


        const getActionData = () => {

            if (garantie === '') {
                return null;
            }

            if (garantie === 0 && sousGarantie === '') {
                return null;
            }

            if (garantie === 1 && (montantDevis === '' || proposition === '')) {
                return null;
            }


            let actionData =
            {
                code: action.code,
                details: [
                    {
                        code: ReclamationActionDetailCodes.Resultat,
                        type: ReclamationActionDetailType.ChoixSimple,
                        libelle: garantieLabel,
                        position: 0,
                        valeurString: garanties[garantie],
                        valeurInteger: garantie
                    }]
            };

            if (garantie === 0) {
                actionData.details.push({
                    code: ReclamationActionDetailCodes.Resultat,
                    type: ReclamationActionDetailType.ChoixSimple,
                    libelle: "Sous garantie :",
                    position: actionData.details.length,
                    valeurString: choixSousGarantie[sousGarantie],
                    valeurInteger: sousGarantie
                });
            }


            if (garantie === 1) {
                if (montantDevis !== '') {
                    actionData.details.push({
                        code: ReclamationActionDetailCodes.MontantDevis,
                        type: ReclamationActionDetailType.Flottant,
                        libelle: "Montant du devis fournisseur (pour échange / réparation)",
                        position: actionData.details.length,
                        valeurFloat: montantDevis
                    });
                }
                if (proposition !== '') {
                    actionData.details.push({
                        code: ReclamationActionDetailCodes.Resultat,
                        type: ReclamationActionDetailType.Texte,
                        libelle: "Proposition service fournisseur (Chrono-spit, ...)   (à vérifier)",
                        position: actionData.details.length,
                        valeurString: proposition
                    });
                }
            }

            return actionData;
        }


        onChange(getActionData());
    }, [action.code, onChange, garantie, sousGarantie, montantDevis, proposition]);

    return (
        <DialogContent>

            <FormControl component="fieldset" className={classes.formControl}>
                <FormLabel component="legend">{garantieLabel}</FormLabel>
                <RadioGroup
                    value={garantie.toString()}
                    onChange={e => setGarantie(parseInt(e.target.value, 10))}
                >
                    {garanties.map((m, index) => (
                        <FormControlLabel key={index} value={index.toString()} control={<Radio />} label={m} />
                    ))}

                </RadioGroup>
            </FormControl>


            {garantie === 0 && (
                <FormControl component="fieldset" className={classes.formControl}>
                    <FormLabel component="legend">{"Sous garantie :"}</FormLabel>
                    <RadioGroup
                        value={sousGarantie.toString()}
                        onChange={e => setSousGarantie(parseInt(e.target.value, 10))}
                    >
                        {choixSousGarantie.map((m, index) => (
                            <FormControlLabel key={index} value={index.toString()} control={<Radio />} label={m} />
                        ))}

                    </RadioGroup>
                </FormControl>
            )}


            {garantie === 1 && (

                <React.Fragment>

                    <TextField
                        className={classes.formControl}
                        value={montantDevis}
                        onChange={e => setMontantDevis(e.target.value)}
                        variant={"filled"}
                        label={"Montant du devis fournisseur (pour échange / réparation)"}
                        type="number"
                        inputProps={{ min: 0 }}
                    />

                    <TextField
                        className={classes.formControl}
                        value={proposition}
                        onChange={e => setProposition(e.target.value)}
                        variant={"filled"}
                        label={"Proposition service fournisseur (Chrono-spit, ...)   (à vérifier)"}
                        multiline
                    />

                </React.Fragment>

            )}

        </DialogContent>
    );

}


export default DemandeExpertiseFournisseurDialogContent;